import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import { Modal, Button, message } from "antd";
import {
  endCodeStatusList,
  prefixFile,
} from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import StubStruts from "@/utils/stubStruts";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import EditEndCodeStatus from "./editEndCodeStatus";

// 国际化切换语言

/**
 * 订单停止原因类型表
*/

// const TabPane = Tabs.TabPane;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class EndCodeStatus extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.tenceCompanyM;
    this.isAdd = '编辑停止原因类型';
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.isFirst = true;
    this.hasSearch = false;
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      tableParam: {
        stubGroupName: this.queryStubName,
        ticketType: "3",
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },
      typeOption: [{
        text: this.props.intl.messages.commonBase.wz10, // '全部',
        value: "",
      }],
      currentParam: {},
    };
  }

  /**
     * 页面加载前调用方法，初始化查询form表单
     */
  componentWillMount() {
    /**
         * 设备状态定义
         */
    this.stateOption = StubStruts();
    /**
         * 初始化form查询表单
         */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    };

    /**
     * 页面加载完成调用方法，表格数据加载，并且初始化值
     */
    componentDidMount() {
      this.fetchApi(this.state.tableParam);
      this.setState({
        stubGroupName: "",
        meterModuleId: "",
        stubId: null,
        tableParam: {
          stubGroupName: "",
          stubGroupId: "",
          meterModuleId: "",
          stubId: "",
          ticketType: "3",
        },
      });
    }

    /**
     * 查询form表单初始化
     */
    initFormConfig = () => {
      const formConfig = {
        childItems: [
          
          {
            type: "input",
            placeholder: '停止原因', // '停止原因',
            param: {
              name: "endInfo",
              type: "string",
            },
            labelName: '停止原因', // '停止原因:',
            required: false,
            defaultValue: "",
          },
        {
            type: "select",
            options: [{
              text: this.yunwei.wz10, // '全部',
              value: "",
            }, {
              text: '故障', // '故障',
              value: "2",
            }, {
              text: '正常', // '正常',
              value: "3",
            }],
            placeholder: '请选择', // '请选择设备类型',
            param: {
              name: "infoType",
              type: "string",
            },
            labelName: '类型', // '类型',
            required: false,
          },

          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                // icon: 'search',
                text: this.internationalization.title16, // '查询'
              },
              // {
              //   btnType: "button",
              //   text: this.internationalization.btn8, // 导出
              //   handler: (e, param) => {
              //     this.exportData(param);
              //   },
              // },
              // {
              //   btnType: "button",
              //   // icon: 'search',
              //   text: '新建', // '查询'
              //   handler: (record) => {
              //     this.isAdd = this.internationalization.btn9;
              //     this.setState({
              //       seeStubStatusVisible: true,
              //       stubId: null,
              //     });
              //   },
              // },
            ],
          },
        ],
        layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
        formTarget: "submit", // 表单提交类型，设置grid则为更新grid
        autoLoadGrid: !0, // 设置为false不触发加载grid
        defaultParams: {
          // stubGroupName: this.queryStubName,
          // powerBoxId: localStorage.meterModuleId,
          meterId: this.queryMeterModuleId,
          stubId: this.queryStubId,
          ticketType: "3",
        },

        context: this,
        tableKey: "cityTypeTable",
        tablePage: "城市类别",
      };
      return formConfig;
    }

    // 数据导出
    // exportData = (param) => {
    //   const excelUrl = `${prefixFile}/exportStubInfo.do`;

    //   param.locale = this.props.intl.locale;

    //   if (param.updateType === this.yunwei.wz10) {
    //     param.updateType = "";
    //   }

    //   if (param.frameWork === this.yunwei.wz10) {
    //     param.frameWork = "";
    //   }
    //   if (param.stubGroupName === this.queryStubName && !this.hasSearch) {
    //     param.stubGroupId = this.queryStubGroupId;
    //   } else {
    //     param.stubGroupId = "";
    //   }

    //   let params = "";
    //   Object.keys(param).forEach((key) => {
    //     if (param[key] !== undefined) {
    //       params += `${key}=${param[key]}&`;
    //     }
    //   });
    //   const ele = document.createElement("a");
    //   ele.download = encodeURI(`${excelUrl}?${params}`);
    //   ele.style.display = "none";
    //   ele.href = encodeURI(`${excelUrl}?${params}`);
    //   ele.target = "_blank"; // 针对 ie模式 的浏览器
    //   // 触发点击
    //   document.body.appendChild(ele);
    //   ele.click();
    //   // 然后移除
    //   document.body.removeChild(ele);
    // }

    /**
     *
     * 表格初始化
     */
    init = () => {
      this.status = null;
      this.ticketType = 3;
      this.deviceType = null;
      this.deviceModel = null;

      this.tableConfig = {
        tableKey: "cityTypeTable",
        tableColumns: [
          {
            name: '停止原因code', // '停止原因code',
            key: "endCode",
            colType: "textCol",
            align: "left",
            width: 200,
          }, 
          {
            name: '停止原因说明', // '停止原因说明',
            key: "endInfo",
            colType: "textCol",
            align: "left",
            width: 200,
          }, 
          {
            name: '类型', // '设备类型'
            key: "status",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 2:
                  return '故障';// 'B类';
                case 3:
                  return '正常';// 'C类';
                default:
                  return '--';// '未知'
              }
            },

          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 320,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: '编辑', 
                handler: (record) => {
                  this.isAdd = this.internationalization.btn11;
                  this.setState({
                    seeStubStatusVisible: true,
                    stubId: record,
                  });
                  
                },
              },
            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        dataApi: endCodeStatusList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      };
    }

    /**
     * 页面内调用，关闭modal弹窗方法
    */
    modalVisibleAction(modalVisibleKey, visible) {
      this.setState({
        [modalVisibleKey]: visible,
      });
    }

    /**
     * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
    */
    cancelModal(key) {
      this.setState({
        [key]: false,
      });
    }

    /**
     * 新开tab页方法
     */
    openTab = (param, e) => {
      this.props.onAdd(e, param);
      // this.props.handle && this.props.handle()
    };

    /**
     * 表格数据加载方法
     */
    fetchApi = (param) => {
      const newParam = param;

      if (newParam.updateType === this.yunwei.wz10) {
        newParam.updateType = "";
      }

      if (newParam.frameWork === this.yunwei.wz10) {
        newParam.frameWork = "";
      }

      if (this.isFirst) {
        this.isFirst = false;
        newParam.stubGroupId = this.queryStubGroupId;
      } else {
        this.hasSearch = true;
        newParam.stubGroupId = "";
        param.stubGroupId = "";
      }
      this.setState({
        tableParam: param,
      });
      newParam.ticketType = "3";
      // 当设置formTarget为grid时，执行自定义提交事件。
      if (this.state.formConfig.formTarget === "grid") {
        return;
      }
      // 请求fetch 对象，带入生成参数
      // 如果在modal中的表单提交，请执行这里
      if (this.props.modalSubmit) {
        return this.props.modalSubmit(newParam);
      } else {
        this.setState({
          currentParam: newParam,
        });
        // 如果正常页面中的表单提交，请执行下面
        return RefreshGrid(this.context.store, "cityTypeTable", newParam);
      }
    }

    // 更新frameType
    updateFramType = () => {
      fetchHandler(endCodeStatusList, {
        stubId: this.stubInfoData.key,
      }).then((res) => {
        if (res && (res.code === "success" || res.code === "ok")) {
          this.setState({
            frameType: res.data[0].updateType,
            frameWork: res.data[0].frameWork,
          });
        }
      });
    }

    render() {
      const Content = <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>


        <Modal
          title={this.isAdd}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => { this.modalVisibleAction("seeStubStatusVisible", false); }}>
          <EditEndCodeStatus
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "cityTypeTable");
            }} />
        </Modal>
        

                      </div>;
      return Content;
    }
}

export default injectIntl(EndCodeStatus);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/endCodeStatus.js